
import API from "../../../app/api";

const PDF_CATALOGUE_URL =
  "https://manage.obsessionsindia.in/api/pdf/catalogue";
const PDF_INVOICE_URL =
  "https://manage.obsessionsindia.in/api/pdf/get-invoice";
/**
 * Generate catalogue PDF from the currently filtered products.
 *
 * @param {Object} payload
 * @returns {Promise<Blob>}
 */
export const generateCataloguePdf = async (payload) => {
  try {
    const response = await API.post(
      PDF_CATALOGUE_URL,
      payload,
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );

    if (!response?.data) {
      throw new Error("PDF response is empty");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Catalogue PDF API Error:",
      error
    );

    // Try to read JSON error returned by backend
    if (
      error?.response?.data instanceof Blob
    ) {
      try {
        const text =
          await error.response.data.text();

        const errorData = JSON.parse(text);

        throw new Error(
          errorData?.message ||
            "Failed to generate catalogue PDF"
        );
      } catch (parseError) {
        if (
          parseError instanceof Error &&
          parseError.message !==
            "Failed to generate catalogue PDF"
        ) {
          throw parseError;
        }
      }
    }

    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to generate catalogue PDF"
    );
  }
};

/**
 * Generate catalogue PDF from the currently filtered products.
 *
 * @param {Object} payload
 * @returns {Promise<Blob>}
 */
export const generateInvoicePdf = async (payload,invoice_no) => {
  try {
    const response = await API.post(
      PDF_INVOICE_URL,
      {
        invoice_url: payload,
        invoice_no:invoice_no
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    const data = response?.data;

    if (!data?.success) {
      throw new Error(
        data?.message || "Failed to generate invoice PDF"
      );
    }

    if (!data?.pdf_base64) {
      throw new Error("PDF response is empty");
    }

    return data;
  } catch (error) {
    console.error("Invoice PDF API Error:", error);

    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to generate invoice PDF"
    );
  }
};
